import React from 'react';
import { Ribbon } from 'lucide-react';
import type { IconProps } from '../types';

export const MammographyRibbon = (props: IconProps) => (
  <Ribbon
    {...props}
    width={22}
    height={22}
    strokeWidth={2.35}
    style={{ ...props.style, color: '#db2777' }}
  />
);

export const MammographyLayoutFourRow = (props: IconProps) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 48 32"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    {...props}
  >
    <rect
      x="2"
      y="8"
      width="9"
      height="16"
      rx="1"
    />
    <rect
      x="13.5"
      y="8"
      width="9"
      height="16"
      rx="1"
    />
    <rect
      x="25.5"
      y="8"
      width="9"
      height="16"
      rx="1"
    />
    <rect
      x="37"
      y="8"
      width="9"
      height="16"
      rx="1"
    />
  </svg>
);

export const MammographyLayoutMlo = (props: IconProps) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 48 32"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    {...props}
  >
    <rect
      x="4"
      y="5"
      width="18"
      height="22"
      rx="1.5"
    />
    <rect
      x="26"
      y="5"
      width="18"
      height="22"
      rx="1.5"
    />
    <path d="M7 9l5-3M41 9l-5-3" />
  </svg>
);

const MammographyBreastLayout = ({ side, ...props }: IconProps & { side: 'R' | 'L' }) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 48 32"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    {...props}
  >
    <rect
      x="8"
      y="3"
      width="14"
      height="26"
      rx="1.5"
    />
    <rect
      x="26"
      y="3"
      width="14"
      height="26"
      rx="1.5"
    />
    <text
      x="24"
      y="19"
      textAnchor="middle"
      fill="currentColor"
      stroke="none"
      fontSize="10"
      fontWeight="600"
    >
      {side}
    </text>
  </svg>
);

export const MammographyLayoutRight = (props: IconProps) => (
  <MammographyBreastLayout
    side="R"
    {...props}
  />
);
export const MammographyLayoutLeft = (props: IconProps) => (
  <MammographyBreastLayout
    side="L"
    {...props}
  />
);

export const MammographyLayoutComparison = (props: IconProps) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 48 32"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    {...props}
  >
    <rect
      x="5"
      y="5"
      width="16"
      height="22"
      rx="1.5"
    />
    <rect
      x="27"
      y="5"
      width="16"
      height="22"
      rx="1.5"
      strokeDasharray="3 2"
    />
  </svg>
);

const MammographyVisualizationIcon = ({ children, ...props }: IconProps) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 32 32"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    {...props}
  >
    {children}
  </svg>
);

export const MammographyRightSize = (props: IconProps) => (
  <MammographyVisualizationIcon {...props}>
    <rect
      x="7"
      y="7"
      width="18"
      height="18"
      rx="1.5"
    />
    <path d="M3 11V3h8M21 3h8v8M29 21v8h-8M11 29H3v-8" />
  </MammographyVisualizationIcon>
);

export const MammographySameSize = (props: IconProps) => (
  <MammographyVisualizationIcon {...props}>
    <rect
      x="3"
      y="8"
      width="11"
      height="16"
      rx="1.5"
    />
    <rect
      x="18"
      y="8"
      width="11"
      height="16"
      rx="1.5"
    />
    <path d="M14 16h4M16 14v4" />
  </MammographyVisualizationIcon>
);

export const MammographyBreastSynchronization = (props: IconProps) => (
  <MammographyVisualizationIcon {...props}>
    <path d="M4 11h21M21 7l4 4-4 4" />
    <path d="M28 21H7M11 17l-4 4 4 4" />
  </MammographyVisualizationIcon>
);

export const MammographyNippleCorrection = (props: IconProps) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    {...props}
  >
    <circle
      cx="10"
      cy="10"
      r="4"
    />
    <path d="M10 1v4m0 10v4M1 10h4m10 0h4" />
  </svg>
);

export const MammographyLesionPlacement = (props: IconProps) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    {...props}
  >
    <circle
      cx="10"
      cy="10"
      r="4.5"
    />
    <path d="M10 2v4m0 8v4M2 10h4m8 0h4" />
    <circle
      cx="10"
      cy="10"
      r="1"
      fill="currentColor"
      stroke="none"
    />
  </svg>
);
